import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useVoucherAccountData(companyId?: number) {
    const { data: voucherAccounts, isPending: isPendingVoucherAccounts } = useQuery({
        queryKey: ['voucher-accounts-options', companyId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.voucher.accounts.all', companyId));
            return data.databaseData;
        },
        enabled: !!companyId,
        placeholderData: [],
        retry: 1,
    });

    return {
        voucherAccounts,
        isPendingVoucherAccounts,
    };
}
